import { SwitchNotAllowedController } from './switchNotAllowed.controller';
import template from './switchNotAllowed.html';

export const switchNotAllowedComponent = {
  name: 'switchNotAllowedComponent',
  restrict: 'E',
  template,
  controller: SwitchNotAllowedController,
  controllerAs: 'vm',
  bindings: {},
};



// WEBPACK FOOTER //
// ./src/app/components/switchNotAllowed/switchNotAllowed.component.js